export default "__VITE_ASSET__qyC_1QYr__"